import { useEffect, useState } from "react";
import axios from "axios";

import "./Plans.css";
import { toast } from "react-toastify";

function Plans() {

    const [plansList, setPlansList] = useState([]);

    const [showModal, setShowModal] = useState(false);

    const [editPlanId, setEditPlanId] = useState(null);
    const [showFeaturesModal,setShowFeaturesModal]=useState(false)
const [selectedFeatures, setSelectedFeatures] = useState("");
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [planToDelete, setPlanToDelete] = useState(null);

// const openFeaturesModal=(features)=>{
//     setSelectedFeatures(features);
//     setShowFeaturesModal(true);
// }

    const [planFormData, setPlanFormData] = useState({
        name: "",
        price: "",
        max_users: "",
        storage_gb: "",
        max_workspaces: "",
        features:"",
        unlimited_users: false,
        unlimited_storage: false,
        unlimited_workspaces: false
    });



    // Load data
    useEffect(() => {
        fetchPlansData();
    }, []);

    const fetchPlansData = async () => {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/plans`);
        setPlansList(res.data);
    };


    // Open Add Modal
    const openAddModal = () => {
        setEditPlanId(null);

        setPlanFormData({
            name: "",
            price: "",
            max_users: "",
            storage_gb: "",
            max_workspaces: "", features: "", // ✅ add this
    unlimited_users: false,
    unlimited_storage: false,
    unlimited_workspaces: false
        });

        setShowModal(true);
    };


    // Open Edit Modal
    const openEditModal = (plan) => {
        setEditPlanId(plan.id);
        setPlanFormData(plan);
        setShowModal(true);
    };


    // Close Modal
    const closeModal = () => {
        setShowModal(false);
    };


    // Handle input
    const handleFormChange = (e) => {
        setPlanFormData({
            ...planFormData,
            [e.target.name]: e.target.value
        });
    };


const handleSave = async () => {

    if (!planFormData.name || !planFormData.price) {
     toast.warning("Name and Price are required");
        return;
    }

    try {

        if (editPlanId) {
            await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/plans/${editPlanId}`, // ✅ FIXED
                planFormData
            );
        } else {
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/plans`,
                planFormData
            );
        }

        closeModal();
        fetchPlansData();
        toast.success(
  editPlanId
    ? "Plan updated successfully"
    : "Plan created successfully"
);

    } catch (error) {
        console.error("Save error:", error);
     toast.error("Failed to save plan");
    }
};



    // Delete
   const handleDelete = async () => {
    try {
        await axios.delete(
          `${process.env.REACT_APP_API_BASE_URL}/plans/${planToDelete}`
        );

        toast.success("Plan deleted successfully");

        fetchPlansData();

        setShowDeleteModal(false);
        setPlanToDelete(null);

    } catch (err) {
        toast.error("Failed to delete plan");
    }
};

    return (
        <div className="plans-mgmt-wrapper">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-2">

                <h3 className="plans-mgmt-heading mb-0">
                    Subscription Plan Management
                </h3>

                <button
                    className="btn btn-primary"
                    onClick={openAddModal}
                >
                    + Add Plan
                </button>

            </div>


            {/* Table */}
            <div className="plans-mgmt-table-wrapper table-responsive table-design">


                <table className="table table-bordered  text-center align-middle table-design">

                    <thead className="table-color-plans">
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Price</th>
                            <th>Users</th>
                            <th>Storage</th>
                            <th>Workspaces</th>
                                  <th>Features</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>

                        {plansList.map((plan) => (
                            <tr key={plan.id}>

                                <td>{plan.id}</td>
                                <td>{plan.name}</td>
                            <td>{plan.price}</td>
<td>{plan.max_users || "Unlimited"}</td>
<td>{plan.storage_gb || "Unlimited"}</td>
<td>{plan.max_workspaces || "Unlimited"}</td>

<td className="feature-preview">

    {plan.features ? (

<span className="feature-tooltip-wrapper" tabIndex="0">

    <span className="feature-text">
        {plan.features.split("\n")[0]}...
    </span>

    <div className="feature-tooltip-box c">
        {plan.features
            .split("\n")
            .filter(f => f.trim() !== "")
            .map((feature, index) => (
                <div key={index}>• {feature}</div>
            ))}
    </div>

</span>


    ) : "—"}

</td>


                                <td>
                                    <button
                                        className="btn btn-sm me-2"
                                        title=""
                                        onClick={() => openEditModal(plan)}
                                    >
                                        <i className="bi bi-pencil "></i>
                                    </button>

                                    <button
                                        className="btn btn-sm"
                                        title=""
                                      onClick={() => {
    setPlanToDelete(plan.id);
    setShowDeleteModal(true);
}}
                                    >
                                        <i className="bi bi-trash3 "></i>
                                    </button>


                                </td>

                            </tr>
                        ))}

                    </tbody>

                </table>

            </div>
{showFeaturesModal && (
    <div className="modal show fade d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

                <div className="modal-header content-background">
                    <h5 className="modal-title">Plan Features</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowFeaturesModal(false)}
                    ></button>
                </div>

                <div className="modal-body">
                    
                 <ul>
    {selectedFeatures
        ?.split("\n")
        .filter(f => f.trim() !== "")
        .map((feature, index) => (
            <li key={index}>{feature}</li>
        ))}
</ul>

                </div>

                {/* <div className="modal-footer">
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowFeaturesModal(false)}
                    >
                        Close
                    </button>
                </div> */}

            </div>
        </div>
    </div>
)}


            {/* Modal */}
            {showModal && (
<div
  className="modal fade show d-block"
  style={{ background: "rgba(0,0,0,0.5)" }}
>

                    <div className="modal-dialog">

                        <div className="modal-content">

                            <div className="modal-header">

                                <h5 className="modal-title">
                                    {editPlanId ? "Edit Plan" : "Add Plan"}
                                </h5>

                                <button
                                    className="btn-close"
                                    onClick={closeModal}
                                />

                            </div>


                            <div className="modal-body">

                                <input
                                    className="form-control mb-2"
                                    name="name"
                                    placeholder="Plan Name"
                                    value={planFormData.name}
                                    onChange={handleFormChange}
                                />

                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="price"
                                    placeholder="Price"
                                    value={planFormData.price}
                                    onChange={handleFormChange}
                                />

                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="max_users"
                                    placeholder="Max Users"
                                    value={planFormData.max_users}
                                    onChange={handleFormChange}
                                />

                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="storage_gb"
                                    placeholder="Storage (GB)"
                                    value={planFormData.storage_gb}
                                    onChange={handleFormChange}
                                />

                                <input
                                    type="text"
                                    className="form-control"
                                    name="max_workspaces"
                                    placeholder="Workspaces"
                                    value={planFormData.max_workspaces}
                                    onChange={handleFormChange}
                                />
<textarea
    className="form-control mt-2"
    name="features"
    placeholder="Enter features (one per line)"
    rows="4"
    value={planFormData.features}
    onChange={handleFormChange}
/>
                            </div>


                            <div className="modal-footer">

                                <button
                                    className="btn btn-secondary"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-primary"
                                    onClick={handleSave}
                                >
                                    Save
                                </button>

                            </div>

                        </div>

                    </div>

                </div>
            )}
            {showDeleteModal && (
  <div
  className="modal fade show d-block"
  onClick={() => {
    setShowDeleteModal(false);
    setPlanToDelete(null);
  }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div
        className="modal-content border-0"
        onClick={(e) => e.stopPropagation()}
        style={{
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >
        <div className="modal-body text-center p-4">
          <div
            style={{
              width: "68px",
              height: "68px",
              background: "#FEECEC",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 18px",
            }}
          >
            <i
              className="bi bi-trash3"
              style={{
                color: "#ef4444",
                fontSize: "28px",
              }}
            ></i>
          </div>

          <h5
            style={{
              fontWeight: 700,
              marginBottom: "10px",
            }}
          >
            Delete Plan?
          </h5>

          <p
            style={{
              color: "#6b7280",
              fontSize: "14px",
              marginBottom: "26px",
            }}
          >
            This action cannot be undone.
          </p>

          <div className="d-flex justify-content-center gap-3">
            <button
              className="btn btn-light px-4"
              onClick={() => {
                setShowDeleteModal(false);
                setPlanToDelete(null);
              }}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

        </div>
    );
}

export default Plans;
